import { useState, useEffect } from 'react';
import useDataBean from '../../../../../../../../core/services/dataBean/useDataBean';
import { _TaxScheme, _TaxSchemeValue, _WorkMaintenanceOrder } from '../../../../../../../../core/services/dataBean/EntityCatalog';
import useModal, { MODAL_LG, MODAL_md, MODAL_XL } from '../../../../../../../theme/Component/hooks/useModal';
import { Modal } from '../../../../../../../theme/Component/Modal';
import { toast } from 'react-toastify';
import { PrintJson } from '../../../../../../../theme/Component/PrintJson';
import usePaginator from '../../../../../../../theme/Component/usePaginator';
import { BasicTable, MASK_DATE } from '../../../../../../../theme/Component/BasicTable';
import { InputDate } from '../../../../../../../theme/Input/InputDate';
import { SelectWorkMaintenanceOrderConstants } from '../../../../../../../contract/etapa-contrato/contrac/ublinvoice/FixedAssetItem/WorkMaintenanceOrder/Selectores/SelectWorkMaintenanceOrderConstants';
import { SelectFixedAsset } from '../../../../../../../contract/etapa-contrato/contrac/ublinvoice/FixedAssetItem/FixedAsset/SelectFixedAsset';
import { BasicButton } from '../../../../../../../theme/Component/BasicButton';
import { ListMenu } from '../../../../../../../theme/Component/ListMenu';
import { HandlerInfoProcess } from '../../../../../../../bpm/config/InfoTramiteComponents/HandlerInfoProcess';



interface Props {
    onChange: any;
    label?: string;
}

interface Formdata {
    idFixedAsset: number;
    idItem: number;
    internalCode: string;
    procedureCode: string;
    state: number;
    From: any;
    Upto: any;
}

const FINANCIAL_TAX = 2;

export const RemoteWorkMaintenanceOrder = ({ onChange, label }: Props) => {

    const { instance, lista, bean, setBean, setLista } = useDataBean(_WorkMaintenanceOrder);
    const paginador = usePaginator();

    const modalInfo = useModal(`Historial del Procedimiento ${bean.ProcedureCode}`, MODAL_XL)

    const [renderValue, setRenderValue] = useState<string>("");
    const [form, setForm] = useState<Partial<Formdata>>({})

    const modal = useModal("Seleccione una Orden de Trabajo", MODAL_LG);

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {
        let Props: any = {
            State: 2
        }

        if (form.state) Props.State = form.state
        if (form.idFixedAsset) Props.FixedAssetID = form.idFixedAsset
        if (form.idItem) Props.IDItem = form.idItem
        if (form.internalCode) Props.FixedAssetItemCode = form.internalCode
        if (form.procedureCode) Props.ProcedureCode = form.procedureCode


        instance.getWorkMaintenanceOrderRender(paginador.page, 15, Props, form.From, form.Upto).then(
            (resp: any) => {
                resp.List.forEach(element => {
                    const data = element.DataBeanProperties;

                    data.AccountEntityData = `${data.AccountNit ?? ""} - ${data.AccountEntity}`
                    data.FAAccountEntity = data.FAAccountNit ? `${data.FAAccountNit ?? ""} - ${data.FAAccountEntity}` : "N/P"
                    data.FAEntity = data.FixedAssetID ? `${data.FixedAssetID} - ${data.FixedAssetDescription}` : "N/P"
                });
                setLista(resp.List);
                paginador.setRecords(resp.NumberOfPages * (15));
                paginador.setPages(resp.NumberOfPages);
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const head = [
        { title: 'ID', property: 'IDWorkMaintenanceOrder', visible: true },
        { title: 'Guia de Mantenimiento Asignado', property: 'ProcedureCode', visible: true },
        { title: 'Maquina', property: 'FAEntity', visible: true },
        { title: 'Codigo Interno', property: 'FixedAssetItemCode', visible: true },
        { title: 'Responsable', property: 'FAAccountEntity', visible: true },
        { title: 'Estado', property: 'StateName', visible: true },
        { title: 'Responsable', property: 'AccountEntityData', visible: true },
        { title: 'Observaciones', property: 'Observations', visible: true },
        { title: 'Fecha', property: 'Since', visible: true, mask: MASK_DATE },
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Historial del Procedimiento', icono: 'ri-history-line', visible: true, evento: () => { modalInfo.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const selectItem = () => {

        if (bean.IDWorkMaintenanceOrder) {
            setRenderValue(`${bean.IDWorkMaintenanceOrder}-${bean.Observations}`)
            modal.close();
            onChange?.(bean)
        } else {
            toast.error("Orden no valida")
        }
    }

    return (
        <>
            <label>{label ? label : 'Gravámenes Financieros'}</label>
            <input
                type="text"
                className="form-control"
                placeholder="Buscar..."
                value={renderValue}
                onClick={() => { modal.open() }}
            />

            <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { selectItem() }}>
                <div className="row">
                    <div className="col-md-4">
                        <InputDate name="" value={form.From} label="Desde" setDate={(e) => { setForm({ ...form, From: e }) }} />
                    </div>
                    <div className="col-md-4">
                        <InputDate name="" value={form.Upto} label="Hasta" setDate={(e) => { setForm({ ...form, Upto: e }) }} />
                    </div>
                    <div className="col-md-4">
                        <label>Guia de Mantenimiento</label>
                        <input type="text" className="form-control" value={form.procedureCode} onChange={(e) => { setForm({ ...form, procedureCode: e.target.value }) }} />
                    </div>
                    <div className="col-md-4">
                        <label>Codigo Interno</label>
                        <input type="text" className="form-control" value={form.internalCode} onChange={(e) => { setForm({ ...form, internalCode: e.target.value }) }} />
                    </div>
                    <div className="col-md-3 ">
                        <BasicButton useMargin eventClick={getLista} icon="ri-search-line" children={`Buscar`} />
                    </div>
                    <BasicTable
                        body={lista}
                        listButtons={listaBotones()}
                        head={head}
                        rowSet={setBean}
                        pageTop={paginador.page}
                        next={paginador.next}
                        back={paginador.back}
                        records={paginador}
                    />

                    <div className="col-md-12">
                        <Modal modal={modalInfo.modal} updateModal={modalInfo.setModal} >
                            <HandlerInfoProcess _ProcedureIMPID={bean.ProcedureIMPID} />
                        </Modal>
                    </div>

                </div>
            </Modal>
        </>
    )
}